var map = {
	"./angle-iron.svg": "819c",
	"./back-to-back-c.svg": "6ae0",
	"./box-section.svg": "88c6",
	"./channel.svg": "ca5f",
	"./i-beam.svg": "5e21",
	"./round.svg": "cb5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a71";